import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class EditableText extends Component {

  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onBlur: PropTypes.func,
    isEdit: PropTypes.bool,
    onPaste: PropTypes.func
  };

  static defaultProps = {
    value: 0,
    onClick: () => {}
  };

  constructor (props) {
    super(props);

    this.state = {
      isEdit: props.isEdit,
      value: props.value
    };
  }

  render () {
    if (this.state.isEdit) {
      return (
        <input
          key={this.props.key}
          type="text"
          autoFocus
          className="editable-text"
          defaultValue={this.props.value}
          onChange={e => {
            if (this.props.onChange)
              this.props.onChange(e.target.value);
            this.setState({
              value: e.target.value
            });
          }}
          onBlur={() => {
            if (this.props.onBlur)
              this.props.onBlur(this.state.value);
            this.setState({
              isEdit: false
            });
          }}
          onPaste={(e) => {
            if (this.props.onPaste) {
              this.props.onPaste(e);
              this.setState({
                isEdit: false
              });
            }
          }}
        />
      );
    } else {
      return (
        <span
          className="editable-text"
          onClick={() => {
            if (this.props.onClick)
              this.props.onClick();
            this.setState({
              isEdit: true
            });
          }}
        >
          {this.props.value}
        </span>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/EditableText/index.js